import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0602c050&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0602c050&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0602c050",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0602c050')) {
      api.createRecord('0602c050', component.options)
    } else {
      api.reload('0602c050', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0602c050&scoped=true", function () {
      api.rerender('0602c050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resource/dictionary/index.vue"
export default component.exports